// This file is auto-generated by Kubb. Do not edit manually.
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

import { payerSchema } from "./payerSchema.ts";

export const recurringWorkRequirementSchema = z.object({
  activeMedicaid: z.optional(
    z
      .lazy(() => payerSchema)
      .describe(
        "Active Medicaid coverage details. Absent when no active coverage is found.",
      ),
  ),
  activeMedicare: z.optional(
    z
      .lazy(() => payerSchema)
      .describe(
        "Active Medicare coverage details. Absent when no active coverage is found.",
      ),
  ),
  entryPointType: z.enum(["RECURRING_WORK_REQUIREMENT"]),
  memberId: z.string(),
  state: z.string(),
  type: z.enum(["VANCE_RECURRING_WORK_REQUIREMENT"]),
  workRequirementDate: z
    .string()
    .date()
    .describe("The date work requirements are due."),
  workspaceId: z.string(),
});
